import { render, staticRenderFns } from "./update-doctor-order.vue?vue&type=template&id=0d451c26&"
import script from "./update-doctor-order.vue?vue&type=script&lang=js&"
export * from "./update-doctor-order.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports